module.exports = __webpack_public_path__ + "static/media/hw.7fa60539.svg";